import { useState, useEffect } from 'react'

export default function useDimensions(file, imageId = 'main-image') {
  const [dimensions, setDimensions] = useState('')
  useEffect(() => {
    if (file && file.src && document.getElementById(imageId)) {
      const currentImage = document.getElementById(imageId)
      currentImage.onload = () => {
        setDimensions(
          `${currentImage.naturalWidth} x ${currentImage.naturalHeight} pixels`,
        )
      }
    }
  }, [file])
  return dimensions
}
